import React, { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import "./HamburgerMenu.scss";

const HamburgerMenu = () => {
  const [showNav, setNav] = useState(false);
  
  const handleShow = () => {
    setNav(!showNav);
  };


  const kebabWrapper = useRef(null);

  useEffect(() => {
      
    document.addEventListener("mousedown", (e) => {
      if (
        kebabWrapper.current !== null &&
        !kebabWrapper.current.contains(e.target)
      ) {
        setNav(!showNav);
      }
    });
    // returned function will be called on component unmount
    return () => {
      document.removeEventListener("mousedown", () => {
        setNav(!showNav);
      });
    };
  }, [kebabWrapper, showNav]);


  const handleLogout = (e) => {
    e.preventDefault();
    localStorage.clear();
    window.location = "/";
  };

  return (
    <div className="hamburger">
      <div className="hamburger__menu-container" onClick={handleShow}>
        <img alt="burger" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAABmJLR0QA/wD/AP+gvaeTAAAAKElEQVRIiWNgGAXDHjAisf/TwmwmKhs6CgYhGE1Fo4ByMJqKRsEQAADWCQMKYvEFtQAAAABJRU5ErkJggg=="/>
      </div>

      {showNav && (
        <ul className="hamburger__menu" ref={kebabWrapper}>
          <div className="hamburger__menu-item-container">
            <li className="hamburger__menu-item hamburger__menu-item-1">
            <Link to="/dashboard" onClick={handleShow}>Dashboard</Link>
            </li>
          </div>
          <div className="hamburger__menu-item-container">
            <li className="hamburger__menu-item hamburger__menu-item-2">
            <Link to="/menu" onClick={handleShow}>Menu</Link>
            </li>
          </div>
          <div className="hamburger__menu-item-container">
            <li className="hamburger__menu-item hamburger__menu-item-3">
              <Link to="/logout" onClick={handleLogout}>
                Logout
              </Link>
            </li>
          </div>
        </ul>
      )}
    </div>
  );
};

export default HamburgerMenu;
